import axios from 'axios'

export default {
    namespaced: true,
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        fetch({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return axios.get(
                '/api/administrator/service-orders/list',
                { params: filter}
            ).finally(() => {
                commit('TOGGLE_PRELOADER', false, {root: true})
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        edit({dispatch}, editedItem) {
            return axios.post(
                '/api/administrator/service-orders/edit/' + editedItem.id,
                prepareData(editedItem)
            ).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        add({dispatch}, editedItem) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/administrator/service-orders/add',
                    prepareData(editedItem)
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        complete({dispatch}, orderId) {
            return new Promise((resolve) => {
                axios.put('/api/administrator/service-orders/complete/' + orderId).then(() => {
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        cancel({dispatch}, payload) {
            return new Promise((resolve) => {
                axios.delete('/api/administrator/service-orders/cancel/' + payload.id, {
                    params: { text: payload.text }
                }).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        completedFetchClient({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return axios.get(
                '/api/manager/service-orders/complete/list',
                { params: filter}
            ).finally(() => {
                commit('TOGGLE_PRELOADER', false, {root: true})
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        completedFetchConsolidated({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return axios.get(
                '/api/manager/service-orders/complete/consolidated',
                { params: filter}
            ).finally(() => {
                commit('TOGGLE_PRELOADER', false, {root: true})
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        }
    }
}

function prepareData (data) {
    return {
        status: data.status,
        service_id: data.service_id,
        client_id: data.client_id,
        hotel_id: data.hotel_id,
        room_id: data.room_id,
        prices: data.prices.filter(item => item.quantity > 0),
        time_preparing: data.time_preparing ? data.time_preparing.toUTCString() : null
    }
}

